import { GOOGLE_MAPS_KEY } from 'shared/helpers/globals';

export const PROPERTY_PLACEHOLDER_IMAGE =
  'https://imgdrop.imgix.net/99a0aa6c96954e39b8f664cb98d7b423.png?w=640';

type GoogleStreetViewLocation =
  | { type: 'address'; street: string; city: string; state: string }
  | { type: 'coordinates'; latitude: number; longitude: number };
type GoogleStreetViewOptions = { width?: number; height?: number };

/** Google street view image url */
export const googleStreetViewUrl = (
  location: GoogleStreetViewLocation,
  options?: GoogleStreetViewOptions,
): string => {
  const locationString =
    location.type === 'address'
      ? `${location.street}, ${location.city}, ${location.state}`
      : `${location.latitude},${location.longitude}`;
  const width = options?.width || 768;
  const height = options?.height || 512;

  return (
    'https://maps.googleapis.com/maps/api/streetview?' +
    `&size=${width}x${height}` +
    `&location=${encodeURIComponent(locationString)}` +
    `&key=${encodeURIComponent(GOOGLE_MAPS_KEY)}`
  );
};
